var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneral = function SvgGeneral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30 3 4.6 8.074a2.5 2.5 0 0 0 1.65 1.25l8.85 2.025a6.15 6.15 0 0 1 3.125 10l-6 7a2.7 2.7 0 0 0-.625 2.025l.9 9.325a5.925 5.925 0 0 1-8.225 6.175l-8.3-3.75a2.5 2.5 0 0 0-2.05 0l-8.3 3.75A5.925 5.925 0 0 1 7.5 42.7l.875-9.325a2.7 2.7 0 0 0-.625-2.025l-6-7a6.15 6.15 0 0 1 3.125-10l8.85-2.025a2.5 2.5 0 0 0 1.65-1.25L20 3a5.8 5.8 0 0 1 10 0"
  })));
};
export default SvgGeneral;